module.exports = __webpack_public_path__ + "8c1ebe08428ebd1bba88806e9d182bc8.svg";